import { SVGIconProps } from "@faire/slate/icons/types";
import React from "react";

import { ToastCloseButton } from "./ToastCloseButton";
import { ToastCtaButton } from "./ToastCtaButton";
import { ToastIcon } from "./ToastIcon";

// Copying the props from the Toast component to allow storybook to find the props
interface IProps {
  /**
   * The CTA text, rendered instead of the close button.
   */
  cta?: string;

  /**
   * The content of the toast.
   */
  description: string;

  /**
   * The icon of the toast.
   */
  Icon?: React.FC<SVGIconProps>;

  /**
   * **web**
   * The callback invoked when the CTA is actioned.
   */
  onCtaClick?: () => void;

  /**
   * **web**
   * The callback invoked when the toast is closed or the CTA is actioned.
   */
  onDismiss?: () => void;
}

export const ToastBase = ({
  description,
  Icon,
  onDismiss,
  cta,
  onCtaClick,
}: IProps) => {
  return (
    <div className="fs-toast__content fs-toast--default">
      <ToastIcon Icon={Icon} />
      <span className="fs-toast__description">{description}</span>
      {cta ? (
        <ToastCtaButton
          className="fs-button--plain"
          onClick={() => {
            onCtaClick?.();
            onDismiss?.();
          }}
          onEscape={onDismiss}
        >
          {cta}
        </ToastCtaButton>
      ) : (
        <ToastCloseButton className="fs-button--primary" onClick={onDismiss} />
      )}
    </div>
  );
};
